import { IUsersListFilters } from '~/services/api/users/types';

const getInitialFilters = (): IUsersListFilters => ({
  name: '',
  programId: '',
});

export default getInitialFilters;
